import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import ExhibitionCard from './ExhibitionCard';
import { Autoplay, Navigation, Pagination } from 'swiper';
import axios from 'axios';
import { apiUrl, bannerImgUrl, goodsImgUrl } from '../../common/urls';

const ExhibitionSwiper = ({ id }) => {
  const [list, setList] = useState([]);

  const getData = async () => {
    const result = await axios.get(apiUrl + '/api/v2/exhibitions', {
      params: { page: 1, perPage: 30, filter: {} },
    });
    setList(result.data.list);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    list.length > 0 && (
      <div className="m_month_event_swiper_wp">
        <Swiper
          className="m_month_event_swiper"
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{ delay: 3500, disableOnInteraction: true }}
          spaceBetween={10}
          slidesPerView={'auto'}
          pagination={{
            clickable: true,
            type: 'fraction',
            el: `#exhibition-swiper-pagination-${id}`,
          }}
          navigation={{
            enabled: true,
            nextEl: `#exhibition-swiper-button-next-${id}`,
            prevEl: `#exhibition-swiper-button-prev-${id}`,
          }}
          loop={true}
          breakpoints={{
            1280: {
              slidesPerView: 3,
            },
            769: {
              slidesPerView: 3,
            },
            481: {
              slidesPerView: 1,
            },
            0: {
              slidesPerView: 'auto',
            },
          }}
        >
          {list.map((exhibition) => {
            return (
              <SwiperSlide key={exhibition.idx}>
                <ExhibitionCard exhibition={exhibition} />
              </SwiperSlide>
            );
          })}
          <div
            id={`exhibition-swiper-pagination-${id}`}
            className="swiper-pagination"
          />
        </Swiper>
        <div
          id={`exhibition-swiper-button-next-${id}`}
          className="swiper-button-next"
        />
        <div
          id={`exhibition-swiper-button-prev-${id}`}
          className="swiper-button-prev"
        />
      </div>
    )
  );
};

export default ExhibitionSwiper;
